export default __webpack_public_path__ + "bml-consolese29d70.jpg";